import devMode from 'components/utils/devMode'

// separate so it can be tested
export const domainFn = bool =>
  bool ? 'http://localhost:3001' : 'http://www1.hardinhomes.com'

export default domainFn(devMode)
